var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "collection-slider-wrapper" },
    [
      _c(
        "div",
        { staticClass: "featured-products__slider" },
        [
          _c("collection-slider", {
            attrs: { data: _vm.data },
            on: { sendToModal: _vm.openSliderModal },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "sliderQuickview",
          staticClass: "quickview-modal",
          attrs: { useTransition: false },
        },
        [
          _c(
            "template",
            { slot: "content" },
            [
              _c("product-top", {
                staticClass: "pdp-top--quickview",
                attrs: { data: _vm.sliderQuickviewData, isQuickview: true },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }